module.exports = __webpack_public_path__ + "img/img_kakao.0fe3f7fb.png";